import { getTooltipText } from '@1js/acui-tooltip';

import { AppButtonProps, useAppButtonKeytip, useAppButtonTooltips } from '.';

export const useMergedTooltipAndKeytipRef = (props: AppButtonProps, ref: React.Ref<HTMLButtonElement>) => {
  const { customTooltip, hideLabel, keytipProps, label, useDirectClick = false } = props;

  // Calculate final ref to use with tooltips and keytips
  const { mergedRef } = useAppButtonTooltips(ref, {
    label: getTooltipText(hideLabel, label, customTooltip),
    direction: props.tooltipDirection,
  });
  return useAppButtonKeytip(mergedRef, props, { keytipProps, useDirectClick });
};
